import getStore from '../store/store';

export function getMergeViewEnabledAccount(): string {
    return getStore().mergedViewEnabledAccount;
}
